<template>
	<div class="container">
		<el-row :gutter="10">
			<el-col :span="24" style="padding:20px; align-items: center;">

				<router-link :to="{ path: '/' }">
					<el-link :underline="false" style="font-size: 17px;">
						<i class="el-icon-house" />首页
					</el-link>
				</router-link>

				<el-link disabled :underline="false" style="font-size: 20px;">
					<i class="el-icon-arrow-right" style="padding-left: 10px; padding-right: 10px;" />
				</el-link>

				<el-link :underline="false" @click="goBack" style="font-size: 17px;">
					上一页
				</el-link>

			</el-col>


			<el-col :span="18" style="padding-right: 3px;">
				<div class="cls_card_css">
					<h3>{{detail.title}}</h3>

					<div style="margin-top: 10px;display: flex;flex-direction: row;justify-content: space-between;">
						<div style="color: #999999;font-size: 13px;">
							<span>{{detail.publishTime}}发布</span>
							<span class="ver_line">|</span>
							<span>{{detail.viewCount}}次浏览</span>
							<span class="ver_line">|</span>
							<span>信息ID：{{detail.id}}</span>
						</div>


						<div v-if="false" style="color: #999999;font-size: 13px;">
							<span>举报</span>
							<span class="ver_line">|</span>
							<span>收藏</span>
							<span class="ver_line">|</span>
							<span>修改</span>
							<span class="ver_line">|</span>
							<span>置顶</span>
						</div>

					</div>

					<el-divider />


					<div style="display: flex; flex-direction: row; ">
						<el-image :src="detail.userAvatar" class="img_info" />

						<div style="margin-left: 20px; width: 65%;">
							<div class="text_info_parent">
								<span style="font-weight: bold;">信息编号：</span>
								<span>
									{{detail.orderNum}}
								</span>
							</div>

							<div class="text_info_parent">
								<span style="font-weight: bold;">发布身份：</span>
								<span>个人</span>
							</div>



							<div class="text_info_parent">
								<span style="font-weight: bold;">信息标签：</span>
								<span>
									{{detail.categoryName}}
								</span>
							</div>



							<div class="text_info_parent">
								<span style="font-weight: bold;">刷新时间：</span>
								<span>
									{{detail.refreshTime}}
								</span>
							</div>


							<div class="text_info_parent">
								<span style="font-weight: bold;">联 系 人 ：</span>
								<span>
									{{detail.userNickname}}
								</span>
							</div>


							<div class="text_info_parent">
								<span style="font-weight: bold;">联系方式：</span>
								<span>
									{{detail.bound_phone}}
								</span>
							</div>
						</div>
					</div>


					<div class="cls_tip_warning">
						<i class="el-icon-warning" style="font-size: 45px;color: red;" />
						<span style="color: #666666; margin-left: 10px;">
							<div>1.提醒您：让你提前汇款，或者价格明显低于市价，均有骗子嫌疑，不要轻易相信。</div>
							<div>2.小贴士：本页信息由用户及第三方发布，真实性、合法性由发布人负责，请仔细甄别。</div>
						</span>
					</div>


					<h3 style="margin-top: 30px;">信息详情</h3>
					<el-divider />
					
					<!-- <el-image class="ad_image" fit="cover" src="https://hequ0350.com/attachment/ggg/pagetop.gif" /> -->

					<p style="padding: 10px;border-radius: 5px; background-color: #f8f8f8;">
						<span>
							{{detail.content}}
						</span>
					</p>
				
					<p style="padding: 10px;border-radius: 5px; background-color: #f8f8f8;">
						<span>
							联系我时，请说是在同城信息分类网站-专注本地信息看到的，谢谢！
						</span>
					</p>

					<el-image v-if='false' v-for="(item,index) in detail.coverImageUrls" :key="index" :src="item"
						class="img_info_detail" />
				</div>

			</el-col>


			<el-col :span="6" style="padding-left: 3px;">
				<div class="cls_card_css">
					<h3 style="margin-bottom: 10px;">用户信息</h3>
					<div style="text-align: center;">
						<el-image class="img_user_header" fit="cover" :src="detail.userAvatar" />
						<h5>{{detail.userNickname}}</h5>
					</div>
				</div>



				<div style="margin-top: 5px;padding-left: 1px;">
					<div v-for="(item,index) in bannerList" :key="index" style="margin-bottom: 2px;">
						<el-image :src="item.imgUrl" fit="contain" alt="轮播图" class="item-img-ad" />
					</div>
				</div>

			</el-col>


		</el-row>

	</div>
</template>

<script>
	import {
		getInfoDetail
	} from '@/api/info.js'

	import {
		getBannerList
	} from '@/api/category.js'



	export default {
		name: 'InfoDetail',
		data() {
			return {
				detail: {},
				bannerList: []
			}
		},



		mounted() {
			this.getInfoDetailById()
			this.loadADBanner()
		},






		methods: {


			async loadADBanner() {
				const bannerResult = await getBannerList()
				if (bannerResult.code == 200) {
					this.bannerList = []
					this.bannerList = bannerResult.data
				}
			},


			async getInfoDetailById() {
				const temResult = await getInfoDetail({
					cmsId: this.$route.query.id
				})
				if (temResult.code == 200) {
					const temp = temResult.data
					if (temp != null && temp.length > 0) {
						this.detail = temp[0]
					}
					console.log(this.detail)
				}
			},

			// 返回列表页
			goBack() {
				this.$router.push({
					path: '/category',
					query: {
						categoryId: this.$route.query.categoryId
					}
				});
			}
		}
	}
</script>

<style scoped>
	.cls_card_css {
		padding: 20px;
		background-color: white;
		border: solid 1px #eeeeee;
	}

	.ver_line {
		padding-left: 10px;
		padding-right: 10px;
	}


	.img_info {
		width: 300px;
		height: 300px;
		border-radius: 3px;
	}


	.img_info_detail {
		width: 100%;
		height: 500px;
	}

	.text_info_parent {
		display: flex;
		flex-direction: row;
		margin-bottom: 20px;
		font-size: 16px;
	}


	.cls_tip_warning {
		padding: 10px;
		margin-top: 20px;
		display: flex;
		flex-direction: row;
		background-color: #f8f8f8;
	}


	.ad_image {
		width: 100%;
		height: auto;
		border-radius: 5px;
	}


	.img_user_header {
		width: 100px;
		height: 100px;
		border-radius: 50%;
	}


	.item-img-ad {
		width: 100%;
		background-color: white;
		border-radius: 3px;
	}
</style>